import React from "react";

import Form from "components/Form";
import { URLS, WORKER_QR_URL, WORKER_URL } from "configs/constants";
import { SOURCE_FETCH_URL } from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";

const initialValues = {
  employee_id: "",
  erml:"",
};

const WorkerDetailPage = () => {
  const formFields = [
    { type: "title", title: "Personal Details" },
    {
      type: "renderonly",
      name: "employee_id",
      key: "employee_id",
      label: "Employee ID",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "name",
      key: "name",
      label: "Name",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "id_type_name",
      key: "id_type_name",
      label: "ID Type",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "id_number",
      key: "id_number",
      label: "ID Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "nationality",
      key: "nationality",
      label: "Nationality",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "worker_type",
      key: "worker_type",
      label: "Worker Type",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "mobile_number",
      key: "mobile_number",
      label: "Mobile Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "imagerender",
      label: "QR Code",
      name: "qr_code",
      key: "qr_code",
      altValue: "worker qr code",
      enableDownload: true,
      enablePrint: true,
      downloadUrl: WORKER_QR_URL,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      name: "api",
      type: "switch",
      label: "API",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      disabled:true,
      color: "primary",
      nolabel: "No",
      yeslabel: "Yes",


    },
    {
      type: "renderonly",
      name: "source",
      label: "Source",
      proxyUrl: SOURCE_FETCH_URL,
      required:true,

      paginated: true,
    },
    {
      type: "renderonly",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      required:true,
      paginated: true,

    },
    

    { type: "title", title: "Employment Details" },
    {
      type: "renderonly",
      name: "status",
      key: "status",
      label: "Status",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "company_name",
      key: "company_name",
      label: "Company",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "zone_name",
      key: "zone_name",
      label: "Zone",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "region_name",
      key: "region_name",
      label: "Region",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "estate_name",
      key: "estate_name",
      label: "Estate",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "division_name",
      key: "division_name",
      label: "Division",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "block_name",
      key: "block_name",
      label: "Block",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "worker_group_name",
      key: "worker_group_name",
      label: "Worker Group",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
  ];

  const formButtons = ["cancel"];

  return (
    <div>
      <Form
        initialValues={initialValues}
        submitUrl={WORKER_URL}
        listRoute={URLS.WORKER_LIST}
        formFields={formFields}
        formButtons={formButtons}
        formTitle="Worker"
        noTypography
      />
    </div>
  );
};

export default WorkerDetailPage;
